import Caption from 'LuxKit/Typography/Caption'
import { FormattedMessage } from 'react-intl'

interface Props {
  departureCity?: string
  destinationCity?: string
}

export function HeroCruiseLocation({ destinationCity, departureCity }: Props) {
  return (
    <Caption variant="large" colour="normal-contrast">
      {departureCity === destinationCity && <FormattedMessage
        id="oSCcDGA97NZTUPZmj6Ku"
        defaultMessage="Starts and ends in <b>{departureCity}</b>"
        description="Label for cruise that departs and returns to the same city, with the city name in bold"
        values={{
          departureCity,
          b: (chunks) => <b>{chunks}</b>,
        }}
      />}
      {departureCity !== destinationCity && <FormattedMessage
        id="SjfwU-O5N60Jfw1hfKca"
        defaultMessage="Starts in <b>{departureCity}</b>. Ends in <b>{destinationCity}</b>"
        description="Label for cruise with different departure and destination cities, with city names in bold"
        values={{
          departureCity,
          destinationCity,
          b: (chunks) => <b>{chunks}</b>,
        }}
      />}
    </Caption>
  )
}
